export default __webpack_public_path__ + "static/media/gfg2.82f04a3f.png";